import { daysUntil } from '@central/ui';

/** "in 40 days", "today", "5 days ago". */
export function formatIn(iso: string, now: Date = new Date()): string {
  const d = daysUntil(iso, now);
  if (d === 0) return 'today';
  if (d > 0) return `in ${d} day${d === 1 ? '' : 's'}`;
  return `${-d} day${d === -1 ? '' : 's'} ago`;
}

export { formatBytes } from '@central/ui';

/** "yyyy-mm-dd" (UTC) for a date input. */
export function toDateInput(iso: string): string {
  return iso.slice(0, 10);
}

/** RFC 3339 midnight UTC for a "yyyy-mm-dd" date input value. */
export function fromDateInput(v: string): string {
  return `${v}T00:00:00Z`;
}

/** "yyyy-mm-ddThh:mm" (UTC) for a datetime-local input. */
export function toDateTimeInput(iso: string): string {
  return iso.slice(0, 16);
}

/** RFC 3339 for a datetime-local input value read as UTC. */
export function fromDateTimeInput(v: string): string {
  return `${v}:00Z`;
}
